var React = require('react');
var objectAssign = require('object-assign');
module.exports = function (props) {
    return React.createElement('svg', objectAssign({}, {
        version: '1.1',
        viewBox: '0 0 14 17'
    }, props), React.createElement('path', {
        d: 'M 3.44,5.5 7,2 10.56,5.5',
        fill: 'none',
        stroke: '#323232',
        strokeWidth: '2',
        strokeLinecap: 'butt'
    }), React.createElement('path', {
        d: 'm 7.115,2.885 0,10.23',
        fill: 'none',
        stroke: '#323232',
        strokeWidth: '2',
        strokeLinecap: 'butt'
    }), React.createElement('path', {
        d: 'm 10,9 3,0 0,7 -12,0 0,-7 3,0',
        fill: 'none',
        stroke: '#323232',
        strokeWidth: '2',
        strokeLinecap: 'butt'
    }));
};


//////////////////
// WEBPACK FOOTER
// ./~/react-icon-loader!./app/images/Share.svg
// module id = 534
// module chunks = 1